import { toast } from "sonner";

export async function copyToClipboard(
  value: string,
  label?: string,
): Promise<void> {
  try {
    await navigator.clipboard.writeText(value);
    const truncated = value.length > 40 ? `${value.slice(0, 40)}…` : value;
    toast.success(
      label ? `${label} copied: ${truncated}` : `Copied: ${truncated}`,
    );
  } catch {
    toast.error("Failed to copy to clipboard");
  }
}
